module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_14.c3f7ba4c.mp3";